{
  "title": "Rary's Telepathic Bond",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level divination (ritual)",
  "level": 5,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (pieces of eggshell from two different kinds of creatures)",
  "duration": "1 hour",
  "description": [
    "You forge a telepathic link among up to eight willing creatures of your choice within range, psychically linking each creature to all the others for the duration. Creatures with Intelligence scores of 2 or less aren’t affected by this spell.",
    "Until the spell ends, the targets can communicate telepathically through the bond whether or not they have a common language. The communication is possible over any distance, though it can’t extend to other planes of existence."
  ],
  "spellLists": ["bard", "wizard"]
}
